import { SalaryMaster } from "../../types/salaryMaster";
import {
  SalaryMasterActions,
  SalaryMasterActionList,
} from "../actions/salaryMasterAction";

interface SalaryMasterState {
  all: SalaryMaster[];
  selectedByEmployeeId: SalaryMaster | null;
}

const initialState: SalaryMasterState = {
  all: [],
  selectedByEmployeeId: null,
};

export const salaryMasterReducer = (
  state: SalaryMasterState = initialState,
  action: SalaryMasterActions,
): SalaryMasterState => {
  switch (action.type) {
    case SalaryMasterActionList.ADD_SALARYMASTER:
      return {
        ...state,
        all: [...state.all, action.data],
      };

    case SalaryMasterActionList.EDIT_SALARYMASTER:
      return {
        ...state,
        all: state.all.map((s) =>
          s.id === action.data.id ? { ...action.data } : s,
        ),
      };

    case SalaryMasterActionList.FETCH_SALARYMASTER:
      return {
        ...state,
        all: action.data,
      };

    //     case SalaryMasterActionList.FETCH_SALARYMASTERBYID:
    // return {
    //   ...state,
    //   selectedByEmployeeId: action.data || null,
    // };

    case SalaryMasterActionList.FETCH_SALARYMASTERBYID:
      return {
        ...state,
        selectedByEmployeeId: Array.isArray(action.data)
          ? action.data[0] || null
          : action.data,
      };

    case SalaryMasterActionList.DELETE_SALARYMASTER:
      return {
        ...state,
        all: state.all.filter((s) => s.id !== action.data),
      };

    default:
      return state;
  }
};
